import React from 'react';
import { Tabs } from '../../Nav_DataComponents/Tabs/Tabs';
import type { MenuCategoryNavigatorProps } from './types';

// ─── MenuCategoryNavigator ────────────────────────────────────────────────────

export function MenuCategoryNavigator({
  categories,
  activeId,
  onChange,
  className,
}: MenuCategoryNavigatorProps) {
  const tabItems = categories.map((cat) => ({
    id: cat.id,
    label: cat.name,
    badge: cat.itemCount,
  }));

  return (
    <div className={className}>
      <Tabs
        items={tabItems}
        activeId={activeId}
        onChange={onChange}
        variant="default"
        scrollable
      />
    </div>
  );
}
